
export const initialState = {
  modalNovoGrupo: false,
  infosEditar: {},
  isEditar: false,
  agrupamentos: [],
  revendedores: [],
  pagination: {}
};

export const mutations = {
  openModalGrupo(state, payload) {
    state.modalNovoGrupo = payload;
  },
  createGrupo(state, payload) {
    payload.id = state.agrupamentos.length + 1;
    const novaListaAgrupamentos = [ ...state.agrupamentos, payload ];
    state.agrupamentos = novaListaAgrupamentos;
  },
  updateGrupo(state, payload) {
    const { nome, vendedores, id } = payload;
    const novaListaAgrupamentos = state.agrupamentos
      .map(g => {
        if (g.id === id) {
          g.vendedores = vendedores;
          g.nome = nome;
        }
        return g;
      });

    state.agrupamentos = novaListaAgrupamentos;
  },
  deleteGrupo(state, payload) {
    const arrayAtualizado = state.agrupamentos.filter(g => {
      return g.id !== payload;
    });
    state.agrupamentos = arrayAtualizado;
  },
  setGrupos(state, payload) {
    if (payload.data) {
      const grupos = payload.data.map(g => {
        return {
          id: g._id,
          nome: g.clusterName,
          vendedores: g.clusterMembers
        };
      });
      state.agrupamentos = grupos;
      return;
    }
    state.agrupamentos = payload;
  },
  setRevendedores(state, payload) {
    if (!payload.length) return;
    state.revendedores = payload;
  },
  setEditar(state, payload) {
    state.isEditar = payload;
  },
  setEditInfos(state, payload) {
    state.infosEditar = payload;
  },
  setEditClusterMembers(state, payload) {
    const ids = payload
      .map(revendedor => revendedor.idVendedor);

    state.revendedores = state.revendedores.map(r => {
      if (ids.includes(r.idVendedor)) {
        r.isSelect = true;
      }
      return r;
    });
  },
  setPagination(state, payload) {
    state.pagination = payload;
  }
};

export const actions = {
  async getGrupos(context) {
    const grupos = await R.Cluster.listarTodos(1);
    context.commit('setGrupos', grupos);
  },
  async excluirUmGrupo(context, payload) {
    await R.Cluster.excluirUm(payload);
    context.commit('deleteGrupo', payload);
  },
  async getRevendedores(context, payload) {
    try {
      const vendedores = await await R.Vendedores.vendedores({ isReseller: true }, payload);

      const { totalVendedores, vendedores: revendedores } = vendedores.data;
      context.commit('setPagination', {
        page: payload || 1,
        size: Math.ceil(totalVendedores / (totalVendedores / 100)),
        total: totalVendedores
      });

      context.commit('setRevendedores', vendedores.data.vendedores);
    } catch (error) {
      console.log(error);
      context.commit('setRevendedores', []);
    }
  },
  async createEstrutura(context, payload) {
    const response = await R.Cluster.criarUmCluster(payload);
    return response;
  },
  async getEstruturaEdit(context, payload) {
    const estrutura = await R.Cluster.listarUm(payload);
    context.commit('openModalGrupo', true);
    context.commit('setEditar', true);
    context.commit('setEditInfos', estrutura.data);
  },
  cleanValuesEdit(context) {
    context.commit('setEditar', false);
    context.commit('setEditInfos', {});
  }
};

export const getters = {
};

export default {
  state: initialState,
  mutations: {
    ...mutations
  },
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
};
